module.exports = __webpack_public_path__ + "img/astral-txt_6.469c715b.svg";